import { DialogPassThroughOptions } from 'primereact/dialog'
import { CSSTransitionProps } from 'primereact/csstransition'
import clsx from 'clsx'

export const dialogConfig: DialogPassThroughOptions = {
  root: ({ state }: { state: any }) => ({
    className: clsx('mk-dialog', {
      'transition-none transform-none !w-screen !h-screen !max-h-full !top-0 !left-0': state.maximized,
    }),
  }),
  header: {
    className: 'mk-dialog__header',
  },
  headerTitle: {
    className: 'mk-dialog__title',
  },
  headerIcons: {
    className: 'mk-dialog__header-icons',
  },
  
  closeButton: {
    className: 'mk-dialog__close',
    'data-testid': 'mk-dialog-close',
  },
  closeButtonIcon: {
    className: 'mk-dialog__close-icon',
  },
  content: ({ state }: { state: any }) => ({
    className: clsx('mk-dialog__content', 'pointer-events-auto', {
      grow: state.maximized,
    }),
  }),
  footer: {
    className: 'mk-dialog__footer',
  },
  mask: ({ state }: { state: any }) => ({
    className: clsx('transition duration-200', { 'bg-black/40': state.containerVisible }),
  }),
  transition: ({ props }): CSSTransitionProps => {
    const transitionProps = {
      enterFromClass: '',
      enterActiveClass: 'transition-all duration-200 ease-out',
      leaveActiveClass: 'transition-all duration-200 ease-out',
      leaveToClass: '',
    }

    if (props.position === 'top') {
      transitionProps.enterFromClass = 'opacity-0 scale-75 translate-x-0 -translate-y-full translate-z-0'
      transitionProps.leaveToClass = 'opacity-0 scale-75 translate-x-0 -translate-y-full translate-z-0'
    } else if (props.position === 'bottom') {
      transitionProps.enterFromClass = 'opacity-0 scale-75 translate-y-full'
      transitionProps.leaveToClass = 'opacity-0 scale-75 translate-x-0 translate-y-full translate-z-0'
    } else if (props.position === 'left' || props.position === 'top-left' || props.position === 'bottom-left') {
      transitionProps.enterFromClass = 'opacity-0 scale-75 -translate-x-full translate-y-0 translate-z-0'
      transitionProps.leaveToClass = 'opacity-0 scale-75 -translate-x-full translate-y-0 translate-z-0'
    } else if (props.position === 'right' || props.position === 'top-right' || props.position === 'bottom-right') {
      transitionProps.enterFromClass = 'opacity-0 scale-75 translate-x-full translate-y-0 translate-z-0'
      transitionProps.leaveToClass = 'opacity-0 scale-75 translate-x-full translate-y-0 translate-z-0'
    } else {
      transitionProps.enterFromClass = 'opacity-0 scale-75'
      transitionProps.leaveToClass = 'opacity-0 scale-75'
    }

    return {
      ...transitionProps,
      addEndListener: () => {},
    }
  },
}
